Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _object_without_properties = require("@swc/helpers/_/_object_without_properties");
var require_logger = require('../utils/logger.cjs');
var require_constant = require('../constant.cjs');
var require_share = require('../utils/share.cjs');
var require_context = require('../utils/context.cjs');
require('../utils/index.cjs');
var require_asyncHook = require('../utils/hooks/asyncHook.cjs');
var require_syncWaterfallHook = require('../utils/hooks/syncWaterfallHook.cjs');
var require_asyncWaterfallHooks = require('../utils/hooks/asyncWaterfallHooks.cjs');
var require_pluginSystem = require('../utils/hooks/pluginSystem.cjs');
require('../utils/hooks/index.cjs');
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/shared/index.ts
var SharedHandler = /*#__PURE__*/ function() {
    "use strict";
    function SharedHandler(host) {
        _class_call_check._(this, SharedHandler);
        this.hooks = new require_pluginSystem.PluginSystem({
            beforeRegisterShare: new require_syncWaterfallHook.SyncWaterfallHook("beforeRegisterShare"),
            afterResolve: new require_asyncWaterfallHooks.AsyncWaterfallHook("afterResolve"),
            beforeLoadShare: new require_asyncWaterfallHooks.AsyncWaterfallHook("beforeLoadShare"),
            loadShare: new require_asyncHook.AsyncHook(),
            resolveShare: new require_syncWaterfallHook.SyncWaterfallHook("resolveShare"),
            initContainerShareScopeMap: new require_syncWaterfallHook.SyncWaterfallHook("initContainerShareScopeMap")
        });
        this.host = host;
        this.shareScopeMap = {};
        this.initTokens = {};
        this._setGlobalShareScopeMap(host.options);
    }
    _create_class._(SharedHandler, [
        {
            key: "registerShared",
            value: function registerShared(globalOptions, userOptions) {
                var _require_share_formatShareConfigs = require_share.formatShareConfigs(globalOptions, userOptions), newShareInfos = _require_share_formatShareConfigs.newShareInfos, allShareInfos = _require_share_formatShareConfigs.allShareInfos;
                Object.keys(newShareInfos).forEach((sharedKey)=>{
                    newShareInfos[sharedKey].forEach((sharedVal)=>{
                        sharedVal.scope.forEach((sc)=>{
                            var _this_shareScopeMap_sc;
                            this.hooks.lifecycle.beforeRegisterShare.emit({
                                origin: this.host,
                                pkgName: sharedKey,
                                shared: sharedVal
                            });
                            if (!((_this_shareScopeMap_sc = this.shareScopeMap[sc]) === null || _this_shareScopeMap_sc === void 0 ? void 0 : _this_shareScopeMap_sc[sharedKey])) this.setShared({
                                pkgName: sharedKey,
                                lib: sharedVal.lib,
                                get: sharedVal.get,
                                loaded: sharedVal.loaded || Boolean(sharedVal.lib),
                                shared: sharedVal,
                                from: userOptions.name
                            });
                        });
                    });
                });
                return {
                    newShareInfos,
                    allShareInfos
                };
            }
        },
        {
            key: "loadShare",
            value: function loadShare(pkgName, extraOptions) {
                return _async_to_generator._(function*() {
                    var host = this.host;
                    var shareOptions = require_share.getTargetSharedOptions({
                        pkgName,
                        extraOptions,
                        shareInfos: host.options.shared
                    });
                    if (shareOptions === null || shareOptions === void 0 ? void 0 : shareOptions.scope) yield Promise.all(shareOptions.scope.map((shareScope)=>_async_to_generator._(function*() {
                            yield Promise.all(this.initializeSharing(shareScope, {
                                strategy: shareOptions.strategy
                            }));
                        }).call(this)));
                    var _ref = yield this.hooks.lifecycle.beforeLoadShare.emit({
                        pkgName,
                        shareInfo: shareOptions,
                        shared: host.options.shared,
                        origin: host
                    }), shareOptionsRes = _ref.shareInfo;
                    require_logger.assert(shareOptionsRes, `Cannot find shared "${pkgName}" in host "${host.options.name}". Ensure the shared config for "${pkgName}" is declared in the federation plugin options and the host has been initialized before loading shares.`);
                    var _ref1 = require_share.getRegisteredShare(this.shareScopeMap, pkgName, shareOptionsRes, this.hooks.lifecycle.resolveShare) || {}, registeredShared = _ref1.shared, useTreesShaking = _ref1.useTreesShaking;
                    if (registeredShared) {
                        var targetShared = require_share.directShare(registeredShared, useTreesShaking);
                        if (targetShared.lib) {
                            require_share.addUseIn(targetShared, host.options.name);
                            return targetShared.lib;
                        } else if (targetShared.loading && !targetShared.loaded) {
                            var factory = yield targetShared.loading;
                            targetShared.loaded = true;
                            if (!targetShared.lib) targetShared.lib = factory;
                            require_share.addUseIn(targetShared, host.options.name);
                            return factory;
                        } else {
                            var asyncLoadProcess = ()=>_async_to_generator._(function*() {
                                    var factory = yield targetShared.get();
                                    require_share.addUseIn(targetShared, host.options.name);
                                    targetShared.loaded = true;
                                    targetShared.lib = factory;
                                    return factory;
                                })();
                            var loading = asyncLoadProcess();
                            this.setShared({
                                pkgName,
                                loaded: false,
                                shared: registeredShared,
                                from: host.options.name,
                                lib: null,
                                loading,
                                treeShaking: useTreesShaking ? targetShared : void 0
                            });
                            return loading;
                        }
                    } else {
                        if (extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.customShareInfo) return false;
                        var _useTreeShaking = require_share.shouldUseTreeShaking(shareOptionsRes.treeShaking);
                        var targetShared1 = require_share.directShare(shareOptionsRes, _useTreeShaking);
                        var asyncLoadProcess1 = ()=>_async_to_generator._(function*() {
                                var factory = yield targetShared1.get();
                                targetShared1.lib = factory;
                                targetShared1.loaded = true;
                                require_share.addUseIn(targetShared1, host.options.name);
                                var _ref = require_share.getRegisteredShare(this.shareScopeMap, pkgName, shareOptionsRes, this.hooks.lifecycle.resolveShare) || {}, gShared = _ref.shared, gUseTreeShaking = _ref.useTreesShaking;
                                if (gShared) {
                                    var targetGShared = require_share.directShare(gShared, gUseTreeShaking);
                                    targetGShared.lib = factory;
                                    targetGShared.loaded = true;
                                    gShared.from = shareOptionsRes.from;
                                }
                                return factory;
                            }).call(this);
                        var loading1 = asyncLoadProcess1();
                        this.setShared({
                            pkgName,
                            loaded: false,
                            shared: shareOptionsRes,
                            from: host.options.name,
                            lib: null,
                            loading: loading1,
                            treeShaking: _useTreeShaking ? targetShared1 : void 0
                        });
                        return loading1;
                    }
                }).call(this);
            }
        },
        {
            /**
	* This function initializes the sharing sequence (executed only once per share scope).
	* It accepts one argument, the name of the share scope.
	* If the share scope does not exist, it creates one.
	*/ key: "initializeSharing",
            value: function initializeSharing() {
                var shareScopeName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : require_constant.DEFAULT_SCOPE, extraOptions = arguments.length > 1 ? arguments[1] : void 0;
                var host = this.host;
                var from = extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.from;
                var strategy = extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.strategy;
                var initScope = extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.initScope;
                var promises = [];
                if (from !== "build") {
                    var initTokens = this.initTokens;
                    if (!initScope) initScope = [];
                    var initToken = initTokens[shareScopeName];
                    if (!initToken) initToken = initTokens[shareScopeName] = {
                        from: this.host.name
                    };
                    if (initScope.indexOf(initToken) >= 0) return promises;
                    initScope.push(initToken);
                }
                var shareScope = this.shareScopeMap;
                var hostName = host.options.name;
                if (!shareScope[shareScopeName]) shareScope[shareScopeName] = {};
                var scope = shareScope[shareScopeName];
                var register = (name, shared)=>{
                    var _activeVersion_shareConfig;
                    var version = shared.version, eager = shared.eager;
                    scope[name] = scope[name] || {};
                    var versions = scope[name];
                    var activeVersion = versions[version] && require_share.directShare(versions[version]);
                    var activeVersionEager = Boolean(activeVersion && ("eager" in activeVersion && activeVersion.eager || "shareConfig" in activeVersion && ((_activeVersion_shareConfig = activeVersion.shareConfig) === null || _activeVersion_shareConfig === void 0 ? void 0 : _activeVersion_shareConfig.eager)));
                    if (!activeVersion || activeVersion.strategy !== "loaded-first" && !activeVersion.loaded && (Boolean(!eager) !== !activeVersionEager ? eager : hostName > versions[version].from)) versions[version] = shared;
                };
                var initRemoteModule = (key)=>_async_to_generator._(function*() {
                        var module = (yield host.remoteHandler.getRemoteModuleAndOptions({
                            id: key
                        })).module;
                        var remoteEntryExports = void 0;
                        try {
                            remoteEntryExports = yield module.getEntry();
                        } catch (error) {
                            remoteEntryExports = yield host.remoteHandler.hooks.lifecycle.errorLoadRemote.emit({
                                id: key,
                                error,
                                from: "runtime",
                                lifecycle: "beforeLoadShare",
                                origin: host
                            });
                            if (!remoteEntryExports) return;
                        } finally{
                            if ((remoteEntryExports === null || remoteEntryExports === void 0 ? void 0 : remoteEntryExports.init) && !module.initing) {
                                module.remoteEntryExports = remoteEntryExports;
                                yield module.init(void 0, void 0, initScope);
                            }
                        }
                    })();
                Object.keys(host.options.shared).forEach((shareName)=>{
                    host.options.shared[shareName].forEach((shared)=>{
                        if (shared.scope.includes(shareScopeName)) register(shareName, shared);
                    });
                });
                if (host.options.shareStrategy === "version-first" || strategy === "version-first") host.options.remotes.forEach((remote)=>{
                    if (remote.shareScope === shareScopeName) promises.push(initRemoteModule(remote.name));
                });
                return promises;
            }
        },
        {
            key: "loadShareSync",
            value: function loadShareSync(pkgName, extraOptions) {
                var host = this.host;
                var shareOptions = require_share.getTargetSharedOptions({
                    pkgName,
                    extraOptions,
                    shareInfos: host.options.shared
                });
                if (shareOptions === null || shareOptions === void 0 ? void 0 : shareOptions.scope) shareOptions.scope.forEach((shareScope)=>{
                    this.initializeSharing(shareScope, {
                        strategy: shareOptions.strategy
                    });
                });
                var _ref = require_share.getRegisteredShare(this.shareScopeMap, pkgName, shareOptions, this.hooks.lifecycle.resolveShare) || {}, registeredShared = _ref.shared, useTreesShaking = _ref.useTreesShaking;
                if (registeredShared) {
                    if (typeof registeredShared.lib === "function") {
                        require_share.addUseIn(registeredShared, host.options.name);
                        if (!registeredShared.loaded) {
                            registeredShared.loaded = true;
                            if (registeredShared.from === host.options.name) shareOptions.loaded = true;
                        }
                        return registeredShared.lib;
                    }
                    if (typeof registeredShared.get === "function") {
                        var module = registeredShared.get();
                        if (!(module instanceof Promise)) {
                            require_share.addUseIn(registeredShared, host.options.name);
                            this.setShared({
                                pkgName,
                                loaded: true,
                                from: host.options.name,
                                lib: module,
                                shared: registeredShared
                            });
                            return module;
                        }
                    }
                }
                if (shareOptions.lib) {
                    if (!shareOptions.loaded) shareOptions.loaded = true;
                    return shareOptions.lib;
                }
                if (shareOptions.get) {
                    var module1 = shareOptions.get();
                    if (module1 instanceof Promise) require_logger.error((extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.from) === "build" ? _module_federation_error_codes.RUNTIME_005 : _module_federation_error_codes.RUNTIME_006, _module_federation_error_codes.runtimeDescMap, {
                        hostName: host.options.name,
                        sharedPkgName: pkgName
                    }, void 0, require_context.optionsToMFContext(host.options));
                    shareOptions.lib = module1;
                    this.setShared({
                        pkgName,
                        loaded: true,
                        from: host.options.name,
                        lib: shareOptions.lib,
                        shared: shareOptions
                    });
                    return shareOptions.lib;
                }
                require_logger.error(_module_federation_error_codes.RUNTIME_006, _module_federation_error_codes.runtimeDescMap, {
                    hostName: host.options.name,
                    sharedPkgName: pkgName
                }, void 0, require_context.optionsToMFContext(host.options));
            }
        },
        {
            key: "initShareScopeMap",
            value: function initShareScopeMap(scopeName, shareScope) {
                var extraOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var host = this.host;
                this.shareScopeMap[scopeName] = shareScope;
                this.hooks.lifecycle.initContainerShareScopeMap.emit({
                    shareScope,
                    options: host.options,
                    origin: host,
                    scopeName,
                    hostShareScopeMap: extraOptions.hostShareScopeMap
                });
            }
        },
        {
            key: "setShared",
            value: function setShared(param) {
                var pkgName = param.pkgName, shared = param.shared, from = param.from, lib = param.lib, loading = param.loading, loaded = param.loaded, get = param.get, treeShaking = param.treeShaking;
                var version = shared.version, _shared_scope = shared.scope, scope = _shared_scope === void 0 ? "default" : _shared_scope, shareInfo = _object_without_properties._(shared, [
                    "version",
                    "scope"
                ]);
                var scopes = Array.isArray(scope) ? scope : [
                    scope
                ];
                var mergeAttrs = (shared)=>{
                    var merge = (s, key, val)=>{
                        if (val && !s[key]) s[key] = val;
                    };
                    var targetShared = treeShaking ? shared.treeShaking : shared;
                    merge(targetShared, "loaded", loaded);
                    merge(targetShared, "loading", loading);
                    merge(targetShared, "get", get);
                };
                scopes.forEach((sc)=>{
                    if (!this.shareScopeMap[sc]) this.shareScopeMap[sc] = {};
                    if (!this.shareScopeMap[sc][pkgName]) this.shareScopeMap[sc][pkgName] = {};
                    if (!this.shareScopeMap[sc][pkgName][version]) this.shareScopeMap[sc][pkgName][version] = _object_spread_props._(_object_spread._({
                        version,
                        scope: [
                            sc
                        ]
                    }, shareInfo), {
                        lib
                    });
                    var registeredShared = this.shareScopeMap[sc][pkgName][version];
                    mergeAttrs(registeredShared);
                    if (from && registeredShared.from !== from) registeredShared.from = from;
                });
            }
        },
        {
            key: "_setGlobalShareScopeMap",
            value: function _setGlobalShareScopeMap(hostOptions) {
                var globalShareScopeMap = require_share.getGlobalShareScope();
                var identifier = hostOptions.id || hostOptions.name;
                if (identifier && !globalShareScopeMap[identifier]) globalShareScopeMap[identifier] = this.shareScopeMap;
            }
        }
    ]);
    return SharedHandler;
}();
//#endregion
exports.SharedHandler = SharedHandler; //# sourceMappingURL=index.cjs.map
